import { useMutation, useQuery, useQueryClient } from "react-query";
import { getIOAssociations, confirmIOAssociation } from "@/api/Histories/association-api";

const key = "io-associations";

export function useIOAssociations(params, options = {}) {
	return useQuery([key, params], () => getIOAssociations(params), {
		enabled: !!params,
		...options,
	});
}

export function useConfirmIOAssociation(listType = null, filters = null) {
	const queryClient = useQueryClient();

	return useMutation((payload) => confirmIOAssociation(payload), {
		onSuccess: (response) => {
			if (response?.updated_data && listType && filters) {
				const { data, total } = response.updated_data;

				queryClient.setQueryData(["histories", "list", listType, filters], (oldData) => {
					if (!oldData) return { data, total };
					return { ...oldData, data, total };
				});
			}

			queryClient.invalidateQueries([key], { refetchActive: false });
		},
	});
}
